const transformFacility = ({ data }) => ({
    available: data.available,
    available_days_message: {
        es: data.booking_date_es,
        eu: data.booking_date_eu,
    },
    booking_slot: data.booking_slot,
    dates: data.dates,
    description: {
        es: data.description_es,
        eu: data.description_eu,
    },
    facility_type: data.id_facility_type,
    email: data.email,
    id: data.id_facility,
    idinstancia: data.idinstancia,
    image: data.image ? `${process.env.REACT_APP_ROOT}hartu/${data.idinstancia}/${data.image}` : null,
    name: {
        es: data.facility_name_es,
        eu: data.facility_name_eu,
    },
    pvp: data.pvp,
    text_info: {
        es: data.text_info_es,
        eu: data.text_info_eu
    },
    time_to_pay: data.time_to_pay,
    has_pellets: data.has_pellets,
    num_pellets: data.num_pellets,
    can_pay_later: data.can_pay_later,
    has_light: data.has_light,
    single_space: data.single_space,
    censed: data.only_for_census,
    can_be_booked: data.can_be_booked,
    can_book_button: data.can_book_button,
    max_bookings_day: data.max_bookings_day,
    max_bookings_month: data.max_bookings_month,
    has_calendar_range: data.has_calendar_range,
    has_calendar_range_consecutive: data.has_calendar_range_consecutive,
    limit_bookings_day_reached: data.limit_bookings_day_reached,
    limit_bookings_month_reached: data.limit_bookings_month_reached,
    has_discount: data.has_discount,
    has_discounts_facility: data.has_discounts_facility,
    phone_mandatory: data.phone_mandatory,
    id_facility_category: data.id_facility_category,
    discount_available: data.discount_available,
    default_prize: data.default_prize,
    limit_instance: data.limit_instance,
    limit_instance_name: data.limit_instance_name,
    best_discount_es: data.best_discount_es,
    best_discount_eu: data.best_discount_eu,
    disability: data.movility_reduce_adapted,
    tributaria: data.tributaria_concept ? true : false,
    bookedTributaria: data.can_be_booked_tributaria,
    payment_type: data.payment_type,
    user_prize: data.user_prize ? {
        id_user: data.user_prize.id_user,
        username: data.user_prize.name,
        dni: data.user_prize.dni,
        surnames: data.user_prize.lastname,
        email: data.user_prize.email,
        phone: data.user_prize.phone,
        postalCode: data.user_prize.cp,
        price: data.user_prize.price,
        lightPrice: data.user_prize.price_with_light
    } : null
})

export default transformFacility